/**
 * UI metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @returns {Object} UI metodları
 */
export const createDocumentUIMethods = (state) => {
  const { expandedFiles, expandAll, files, selectedDocumentIds } = state


  /**
   * Bir dosyanın genişletme durumunu değiştir
   * @param {String} fileId - Dosya ID'si
   */
  const toggleExpand = (fileId) => {
    const index = expandedFiles.value.indexOf(fileId)
    if (index === -1) {
      expandedFiles.value.push(fileId)
    } else {
      expandedFiles.value.splice(index, 1)
    }
  }

  /**
   * Tüm dosyaları genişletme durumunu değiştir
   */
  const toggleExpandAll = () => {
    expandAll.value = !expandAll.value
  }

  /**
   * Bir dosyayı listeden kaldır
   * @param {Number} index - Silinecek dosyanın indeksi
   */
  const removeFile = (index) => {
    files.value.splice(index, 1)
  }

  /**
   * Dosya açıklamasını güncelle
   * @param {Number} index - Güncellenecek dosyanın indeksi
   * @param {String} newDescription - Yeni açıklama
   */
  const updateDescription = (index, newDescription) => {
    if (!files.value[index]) return
    files.value[index].description = newDescription
  }

  /**
   * Belge seçim işlemi
   * @param {Array|String|Number} documentIds - Belge ID'leri dizisi veya tekil ID
   * @param {Boolean} selected - Tekil ID için seçim durumu
   */
  const handleDocumentSelection = (documentIds, selected) => {
    // Array olarak geldiyse, doğrudan seçili ID'leri güncelle
    if (Array.isArray(documentIds)) {
      selectedDocumentIds.value = [...documentIds];
      return;
    }

    // Tekil ID ve seçim durumu geldiyse (eski metod uyumluluğu)
    if (selected) {
      if (!selectedDocumentIds.value.includes(documentIds)) {
        selectedDocumentIds.value.push(documentIds)
      }
    } else {
      selectedDocumentIds.value = selectedDocumentIds.value.filter(id => id !== documentIds)
    }
  }

  // Public API
  return {
    toggleExpand,
    toggleExpandAll,
    removeFile,
    updateDescription,
    handleDocumentSelection,
  }
}